import { Box, Typography, Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { Palette } from '@/themes/themeOverrides/Palette';

export const CustomConfirmContent = ({ content, handleDialogClose, handleConfirm, loading }) => {
    const translate = useTranslate();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: '48px 40px 40px',
            }}
        >
            <Typography variant='h5' component='h5' sx={{ marginBottom: '16px' }}>
                {translate('common.confirmTitle')}
            </Typography>
            <Typography variant='body1' component='p' sx={{ marginBottom: '40px', fontSize: '16px', color: Palette.black }}>
                {content}
            </Typography>
            <Box sx={{ display: 'flex', gap: '16px' }}>
                <Button onClick={handleDialogClose} color='secondary' variant='contained' disabled={loading} sx={{ width: '100%' }}>
                    {translate('common.cancel')}
                </Button>
                <Button onClick={handleConfirm} color='primary' variant='contained' disabled={loading} sx={{ width: '100%' }}>
                    {translate('common.confirmAction')}
                </Button>
            </Box>
        </Box>
    );
};

CustomConfirmContent.propTypes = {
    content: PropTypes.string.isRequired,
    handleDialogClose: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};
